module.exports = __webpack_public_path__ + "img/rewards-coin.green.b4e37bf5.svg";